// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__p3Myv","sliderInBannerContainer":"styles_sliderInBannerContainer__ZqDMu"};